const KEY = 'chatStorage';

export const loadStorageState =()=>{
    try{
        const serializeState = sessionStorage.getItem(KEY);
        if(!serializeState) return undefined;
        return JSON.parse(serializeState);
    }catch(err){
        return undefined;
    }
};

export const localStorageSaveState = state =>{
    try{
        const serializeState = JSON.stringify(state);
        sessionStorage.setItem(KEY, serializeState);
    }catch(err){
        
    }
}